import constate from 'constate'

import useSelectedAddresses from '@ecm/ui/hook/UseSelectedAddresses'

const [SelectedAddressesProvider, useSelectedAddressesContext] = constate(useSelectedAddresses)
export { SelectedAddressesProvider, useSelectedAddressesContext }
